import React, { PropsWithChildren } from 'react';
import { Flex, Text } from '@mantine/core';

export const QuestionTitle: React.FC<PropsWithChildren<{ size?: number; subtitle?: string }>> = ({
  children,
  size,
  subtitle,
}) => {
  return (
    <Flex direction="column" gap={8}>
      <Text
        size={size || 32}
        weight={700}
        lh={1.05}
        ta="left"
        sx={{
          letterSpacing: '-1.12px',
        }}
      >
        {children}
      </Text>
      {subtitle && (
        <Text
          size={20}
          weight={700}
          lh={1.2}
          sx={(theme) => ({
            color: theme.colors['type-dark-secondary'],
            letterSpacing: '-0.4px',
          })}
        >
          {subtitle}
        </Text>
      )}
    </Flex>
  );
};
